import { ApiHandler } from "./ApiHandler";

// ===== SINGLETON INSTANCE =====
const apiHandler = new ApiHandler();

// ===== EXPORTS =====
export const apiRequest = async (request, toastMessageConfig = {}) => {
  return apiHandler.apiRequest(request, toastMessageConfig);
};

export const enhancedApiRequest = async (
  request,
  toastMessageConfig = {},
  options = {}
) => {
  return apiHandler.apiRequest(request, toastMessageConfig, options);
};

export const invalidateCache = (pattern) => {
  apiHandler.invalidateCache(pattern);
};
export const cleanupApiHandler = () => {
  apiHandler.cleanup();
};

export { apiHandler, ApiHandler };
